const state = {
  login: 0,
  account: '',
  user_id: 0,
  login_for: '/home'
}

const getters = {
  login: state => state.login,
  account: state => state.account,
  userId: state => state.user_id,
  LoginFor: state => state.login_for
}

const actions = {
  loginOut ({ commit }, data) {
    commit('changeLogin', 0)
    commit('changeUserId', '')
    commit('changeAccount', '')
  },
  setLogin ({ commit }, data) {
    commit('changeLogin', data)
  },
  setLoginFor ({ commit }, data) {
    commit('changeLoginFor', data)
  },
  setAccount ({ commit }, data) {
    commit('changeAccount', data)
  },
  setUserId ({ commit }, data) {
    commit('changeUserId', data)
  }
}

const mutations = {
  changeLogin (state, data) {
    state.login = data
  },
  changeAccount (state, data) {
    state.account = data
  },
  changeUserId (state, data) {
    state.user_id = data
  },
  changeLoginFor (state, data) {
    state.login_for = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user_info.js